(function () {
	'use strict';

	// === READ CONFIG FROM BLOCK DATA ATTRIBUTES ===
	// This element is added via the theme editor block. If it's missing, we don't run.
	var configEl = document.getElementById('et-kaching-config');
	if (!configEl) return;

	var CONFIG = {
		optionName:      configEl.dataset.optionName || 'Aantal',
		piecesPerUnit:   parseInt(configEl.dataset.piecesPerUnit, 10) || 4,
		unitLabel:       configEl.dataset.unitLabel || 'stoel',
		unitLabelPlural: configEl.dataset.unitLabelPlural || 'stoelen',
		piecesLabel:     configEl.dataset.piecesLabel || 'stuks',
		perLabel:        configEl.dataset.perLabel || 'per',
		savingsLabel:    configEl.dataset.savingsLabel || 'Bespaar',
		disableUnitConversion: configEl.dataset.disableUnitConversion === 'true',
		// Only set on the test version (main-product-blocks-new.liquid);
		// absent/empty on the control version, so preselect never runs there.
		preselectBar:    parseInt(configEl.dataset.preselectBar, 10) || 0
	};

	// === HELPERS ===
	function num(text) {
		if (!text) return 0;
		return parseFloat(text.replace(/[^\d,.-]/g, '').replace(',', '.'));
	}

	function fmt(val) {
		return val.toFixed(2).replace('.', ',');
	}

	function extractInt(str) {
		var m = str && str.match(/(\d+)/);
		return m ? parseInt(m[1], 10) : null;
	}

	// === GET SELECTED OPTION VALUE ===
	function getSelectedAantal() {
		// 1. Direct check of radios or selects
		var sel = 'input[name="' + CONFIG.optionName + '"]:checked, ' +
		          'input[name="options[' + CONFIG.optionName + ']"]:checked, ' +
		          'select[name="' + CONFIG.optionName + '"], ' +
		          'select[name="options[' + CONFIG.optionName + ']"]';
		var el = document.querySelector(sel);
		if (el) return el.value;

		// Fallback: read from Kaching's current-variant-id
		var kEl = document.querySelector('kaching-bundles-block');
		if (!kEl) return null;
		try {
			var prod = JSON.parse(kEl.getAttribute('product'));
			var vid = parseInt(kEl.getAttribute('current-variant-id'), 10);
			var v = null;
			for (var i = 0; i < prod.variants.length; i++) {
				if (prod.variants[i].id === vid) { v = prod.variants[i]; break; }
			}
			if (!v) return null;
			var opt = null;
			for (var j = 0; j < prod.options.length; j++) {
				if (prod.options[j].name === CONFIG.optionName) { opt = prod.options[j]; break; }
			}
			if (!opt) return null;
			return v.options[opt.position - 1];
		} catch (e) { return null; }
	}

	// === OVERRIDE CSS VARIABLES ===
	function overrideVars() {
		var block = document.querySelector('.kaching-bundles__block');
		if (!block) return;
		block.style.setProperty('--bar-border-color', 'rgba(34, 34, 34, 0.12)');
		block.style.setProperty('--bar-selected-border-color', '#222222');
		block.style.setProperty('--bar-most-popular-background-color', '#222222');
		block.style.setProperty('--bar-most-popular-color', '#ffffff');
	}

	// === PRESELECT BAR (test version only) ===
	var preselectDone = false;
	var userInteracted = false;

	function preselectBar() {
		if (!CONFIG.preselectBar || preselectDone || userInteracted) return;

		var bars = document.querySelectorAll('.kaching-bundles__bar');
		if (bars.length < CONFIG.preselectBar) return;

		var input = bars[CONFIG.preselectBar - 1].querySelector('input[type="radio"]');
		if (!input) return;

		preselectDone = true;
		if (!input.checked) input.click();
	}

	// === PRICE INTEGRITY GUARD (runs on both versions, inert while healthy) ===
	// Theme scripts recompute the price from a fetched product.js payload that
	// apps (Kaching patches window.fetch) can alter, which leaves the
	// struck-through compare-at price equal to the sale price. The inline
	// Liquid variant JSON on the page is not affected by fetch patching, so it
	// is used as the source of truth: restore the real compare-at price from
	// it, or hide the struck price when the variant has no higher compare-at.
	// While the displayed prices are consistent, nothing is touched.
	var variantTruth = null;

	function getVariantTruth() {
		if (variantTruth) return variantTruth;
		var picker = document.querySelector('variant-picker');
		var scopes = picker && picker.parentElement ? [picker.parentElement, document] : [document];
		for (var s = 0; s < scopes.length; s++) {
			var scripts = scopes[s].querySelectorAll('script[type="application/json"]');
			for (var i = 0; i < scripts.length; i++) {
				if (scripts[i].id === 'variantGroup') continue;
				try {
					var data = JSON.parse(scripts[i].textContent);
					if (Array.isArray(data) && data.length && data[0] && data[0].id && 'price' in data[0]) {
						variantTruth = data;
						return data;
					}
				} catch (e) { /* not variant data */ }
			}
		}
		return null;
	}

	function getSelectedVariantFromTruth() {
		var data = getVariantTruth();
		if (!data) return null;
		var input = document.querySelector('form.main-product-form [name="id"]') ||
		            document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
		if (!input || !input.value) return null;
		var id = parseInt(input.value, 10);
		for (var i = 0; i < data.length; i++) {
			if (data[i].id === id) return data[i];
		}
		return null;
	}

	function fixPriceRoot(root) {
		var saleEl = root.querySelector('.f-price__sale .f-price-item--sale');
		var compareEl = root.querySelector('.f-price__sale s.f-price-item--regular');
		if (!saleEl || !compareEl) return;

		var saleText = saleEl.textContent.trim();
		var compareText = compareEl.textContent.trim();
		if (!saleText) return;

		var variant = getSelectedVariantFromTruth();
		var onSale = !!(variant && variant.compare_at_price && variant.compare_at_price > variant.price);

		if (onSale) {
			root.classList.add('f-price--on-sale');
			if (compareText === saleText) {
				var fm = window.formatMoney;
				var mf = window.FoxThemeSettings && window.FoxThemeSettings.money_format;
				// Rewrite only when our formatting provably matches the theme's
				if (typeof fm === 'function' && mf && fm(variant.price, mf).trim() === saleText) {
					compareEl.textContent = fm(variant.compare_at_price, mf).trim();
					compareEl.style.removeProperty('display');
				} else {
					compareEl.style.display = 'none';
				}
			} else {
				compareEl.style.removeProperty('display');
			}
		} else if (compareText === saleText) {
			// A struck-through price equal to the actual price is always wrong
			if (variant) root.classList.remove('f-price--on-sale');
			compareEl.style.display = 'none';
		} else if (compareText) {
			compareEl.style.removeProperty('display');
		}
	}

	var priceFixTimer = null;
	function fixPriceDisplays() {
		clearTimeout(priceFixTimer);
		priceFixTimer = setTimeout(function () {
			var roots = document.querySelectorAll('[id^="f-product-price-"] .f-price, .sticky-atc-bar__product-info .f-price');
			roots.forEach(fixPriceRoot);
		}, 60);
	}

	var priceObserver = new MutationObserver(fixPriceDisplays);

	function watchPriceDisplays() {
		var containers = document.querySelectorAll('[id^="f-product-price-"], .sticky-atc-bar__product-info');
		containers.forEach(function (el) {
			if (el.dataset.etPriceGuard) return;
			el.dataset.etPriceGuard = '1';
			priceObserver.observe(el, { childList: true, characterData: true, subtree: true });
		});
		if (containers.length) fixPriceDisplays();
	}

	// === MAIN UPDATE ===
	function update() {


		var bars = document.querySelectorAll('.kaching-bundles__bar');
		if (bars.length === 0) return;

		preselectBar();
		overrideVars();

		var aantalVal = CONFIG.disableUnitConversion ? null : getSelectedAantal();
		var basePieces = extractInt(aantalVal);

		bars.forEach(function (bar, idx) {
			var qty = idx + 1;

			// === UPDATE TITLE ===
			if (basePieces) {
				var totalPieces = basePieces * qty;
				var totalUnits = totalPieces / CONFIG.piecesPerUnit;
				var unitWord = totalUnits === 1 ? CONFIG.unitLabel : CONFIG.unitLabelPlural;
				var titleEl = bar.querySelector('.kaching-bundles__bar-title');
				if (titleEl) {
					if (!titleEl.dataset.originalTitle) {
						titleEl.dataset.originalTitle = titleEl.textContent.trim();
					}
					var originalTitle = titleEl.dataset.originalTitle;
					var newHtml = originalTitle + ' <span class="kaching-bundles__stuks">(' + totalUnits + ' ' + unitWord + ' - ' + totalPieces + ' ' + CONFIG.piecesLabel + ')</span>';
					if (titleEl.innerHTML !== newHtml) {
						titleEl.innerHTML = newHtml;
					}
				}
			}

			// === PER-UNIT PRICE ===
			var priceEl = bar.querySelector('.kaching-bundles__bar-price');
			var price = priceEl ? num(priceEl.textContent) : 0;
			var secondLine = bar.querySelector('.kaching-bundles__bar-second-line');

			if (secondLine && basePieces && price > 0) {
				var unitsForPrice = (basePieces * qty) / CONFIG.piecesPerUnit;
				var perUnit = price / unitsForPrice;
				var perEl = secondLine.querySelector('.kaching-bundles__per-unit-price');
				if (!perEl) {
					perEl = document.createElement('div');
					perEl.className = 'kaching-bundles__per-unit-price';
					secondLine.appendChild(perEl);
				}
				perEl.textContent = fmt(perUnit) + ' ' + CONFIG.perLabel + ' ' + CONFIG.unitLabel;
			}

			// === SAVINGS BADGE ===
			var fullPriceEl = bar.querySelector('.kaching-bundles__bar-full-price');
			var pricingEl = bar.querySelector('.kaching-bundles__bar-pricing');
			if (fullPriceEl && priceEl && pricingEl) {
				var fullPrice = num(fullPriceEl.textContent);
				var currentPrice = num(priceEl.textContent);
				var savings = fullPrice - currentPrice;

				if (savings > 0.01) {
					var badge = pricingEl.querySelector('.kaching-bundles__savings-badge');
					if (!badge) {
						badge = document.createElement('span');
						badge.className = 'kaching-bundles__savings-badge';
						pricingEl.insertBefore(badge, fullPriceEl);
					}
					badge.textContent = CONFIG.savingsLabel + ' ' + fmt(savings);
				}
			}
		});

		updateVariantPickerLabels();
	}

	function updateVariantPickerLabels() {
		if (CONFIG.disableUnitConversion) return;

		var pickers = document.querySelectorAll('.variant-picker__field[data-option-name="' + CONFIG.optionName + '"]');
		pickers.forEach(function (picker) {
			// 1. Update the buttons/labels for each option value
			var options = picker.querySelectorAll('.variant-picker__option');
			options.forEach(function (opt) {
				var val = opt.dataset.value;
				var pieces = extractInt(val);
				if (pieces) {
					var units = pieces / CONFIG.piecesPerUnit;
					var word = units === 1 ? CONFIG.unitLabel : CONFIG.unitLabelPlural;
					var newText = units + ' ' + word + ' (' + pieces + ' ' + CONFIG.piecesLabel + ')';

					var label = opt.querySelector('.variant-picker__option-button');
					if (label) {
						if (!label.dataset.originalText) {
							label.dataset.originalText = label.textContent.trim();
						}
						if (label.textContent !== newText) {
							label.textContent = newText;
						}
					}
				}
			});

			// 2. Update the "Selected Value" text in the label above buttons
			var selectedValEl = picker.querySelector('.selected-value');
			if (selectedValEl) {
				var checkedInput = picker.querySelector('input:checked') || picker.querySelector('select');
				var rawVal = checkedInput ? (checkedInput.value || checkedInput.textContent) : selectedValEl.textContent;
				var pieces = extractInt(rawVal);
				if (pieces) {
					// Only convert if it looks like pieces (not already converted)
					// or if we're reading from the raw input value which is always pieces
					if (checkedInput || (rawVal.indexOf(CONFIG.unitLabel) === -1 && rawVal.indexOf(CONFIG.unitLabelPlural) === -1)) {
						var units = pieces / CONFIG.piecesPerUnit;
						var word = units === 1 ? CONFIG.unitLabel : CONFIG.unitLabelPlural;
						var newVal = units + ' ' + word + ' (' + pieces + ' ' + CONFIG.piecesLabel + ')';
						if (selectedValEl.textContent !== newVal) {
							selectedValEl.textContent = newVal;
						}
					}
				}
			}

			// 3. Handle dropdowns
			var select = picker.querySelector('select');
			if (select) {
				Array.from(select.options).forEach(function (opt) {
					var pieces = extractInt(opt.value);
					if (pieces) {
						var units = pieces / CONFIG.piecesPerUnit;
						var word = units === 1 ? CONFIG.unitLabel : CONFIG.unitLabelPlural;
						if (!opt.dataset.originalLabel) {
							opt.dataset.originalLabel = opt.textContent.trim();
						}
						var newOptText = units + ' ' + word + ' (' + pieces + ' ' + CONFIG.piecesLabel + ')';
						if (opt.textContent !== newOptText) {
							opt.textContent = newOptText;
						}
					}
				});
			}
		});
	}

	// === INIT ===
	var debounceTimer = null;
	function debouncedUpdate() {
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(update, 80);
	}

	function bindEvents() {
		// 1. Variant option changes
		document.body.addEventListener('change', function (e) {
			var name = e.target.name || "";
			var isOption = name === CONFIG.optionName || 
			               name === 'options[' + CONFIG.optionName + ']' ||
			               e.target.closest('[data-option-name="' + CONFIG.optionName + '"]');

			if (isOption) {
				updateVariantPickerLabels();
				debouncedUpdate();
			} else if (e.target.closest('.kaching-bundles')) {
				debouncedUpdate();
			}
		});

		// 2. Kaching custom element events
		var kEl = document.querySelector('kaching-bundle, kaching-bundle-component, kaching-bundles-block');
		if (kEl) {
			kEl.addEventListener('loaded', update);
			kEl.addEventListener('items-changed', debouncedUpdate);
		}

		// 3. Theme specific events (Variant Changes)
		var picker = document.querySelector('variant-picker');
		if (picker && picker.dataset.productId && window.FoxThemeEvents) {
			window.FoxThemeEvents.subscribe(picker.dataset.productId + '__VARIANT_CHANGE', debouncedUpdate);
		}

		// 4. Targeted observer for the selected-value span to kill the flash
		if (picker) {
			var labelObserver = new MutationObserver(function () {
				updateVariantPickerLabels();
			});
			var selectedLabels = picker.querySelectorAll('.selected-value');
			selectedLabels.forEach(function (l) {
				labelObserver.observe(l, { childList: true, characterData: true, subtree: true });
			});
		}
	}

	// A real user click on the bundle bars wins over a late preselect
	document.body.addEventListener('click', function (e) {
		if (e.isTrusted && e.target.closest('.kaching-bundles')) userInteracted = true;
	}, true);

	// Initial setup
	watchPriceDisplays();
	// The sticky ATC bar section sits below this script in the DOM
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', watchPriceDisplays);
	}
	update();
	bindEvents();

	// Fallback for delayed initialization
	document.addEventListener('kachingBundlesInitialized', function () {
		update();
		bindEvents();
	});

	// Polling fallback (less aggressive)
	var pollCount = 0;
	var poll = setInterval(function () {
		pollCount++;
		if (window.kachingBundlesInitialized || document.querySelector('.kaching-bundles__bar')) {
			clearInterval(poll);
			update();
			bindEvents();
		}
		if (pollCount > 30) clearInterval(poll); 
	}, 200);
})();
